var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning-container"},[_c('p',[_vm._v(_vm._s(_vm.message))]),_c('button',{staticClass:"action",on:{"click":function($event){$event.stopPropagation();return _vm.resetTimer.apply(null, arguments)}}},[_vm._v("Renew Session")])])
}
var staticRenderFns = []

export { render, staticRenderFns }